// @ngInject
function restrictAccess(AuthService) {
    return {
        restrict: 'A',
        scope: false,
        compile:  function(element, attr) {
            if (!attr.access || AuthService.canAccess(attr.access, attr.permission)) {
                return;
            }

            // For IE 8
            angular.forEach(element.children(), function(elm) {
                try {
                    elm.remove();
                }
                catch (ignore) {}
            });

            element.remove();
        }
    };
}

angular
    .module('directives.restrictAccess', [])
    .directive('access', restrictAccess);
